import { FunctionComponent } from 'react'

import { useSelector } from 'react-redux'

import { PrimaryAlert } from 'src/Components/PrimaryAlert'
import { getReferralHashError } from 'src/Redux/referral-process/referralHash'
import { getReferralError } from 'src/Redux/referral-process/referralList/selectors'

export const ErrorBlock: FunctionComponent = () => {
  const referralListError = useSelector(getReferralError)
  const referralHashError = useSelector(getReferralHashError)

  if (!referralListError && !referralHashError) {
    return null
  }

  return (
    <PrimaryAlert type='danger' hasCross={false}>
      <div>
        <span>Oops! Something went wrong. Please try again later.</span>
      </div>
    </PrimaryAlert>
  )
}
